import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import FeatureContent from './FeatureContent';
import UIFlex from 'UIComponents/layout/UIFlex';
import SuiteStarterCard from '../merch-card/Ebx632SuiteStarterCard';
import UIBox from 'UIComponents/layout/UIBox';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "UpgradeConfigContent__FlexContainer",
  componentId: "sc-7sgwmc-0"
})(["z-index:1;padding-top:48px;", ";"], breakpoint.tablet(_t || (_t = _`
  padding-right: 48px;
  padding-left: 48px;
`)));

const UpgradeConfigContent = ({
  upgradeConfig
}) => {
  return /*#__PURE__*/_jsxs(FlexContainer, {
    children: [/*#__PURE__*/_jsx(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-7",
      children: /*#__PURE__*/_jsx(FeatureContent, {
        upgradeConfig: upgradeConfig
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      grow: 0,
      children: /*#__PURE__*/_jsx(SuiteStarterCard, {})
    })]
  });
};

export default UpgradeConfigContent;